import AdminQuoteDetailsPage from './AdminQuoteDetailsPage';
export default AdminQuoteDetailsPage;
